import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";

export default class LinieTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.renderPrzedzialy = this.renderPrzedzialy.bind(this)
        this.renderNazwaTrasy = this.renderNazwaTrasy.bind(this)
    }

    renderPrzedzialy(cell, row) {
        return <span>
            <div><i>J:</i> {row.przedzialKm}</div>
            <div><i>M:</i> {row.przedzialKmMies}</div>
        </span>
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj linie'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń linie'}/>
            </div>
        )
    }

    renderNazwaTrasy(cell, row) {
        let trasa = this.props.trasy.find(t => t.idTr === cell)
        if (Boolean(trasa)) {
            return trasa.nazTr
        }
    }

    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idLi' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='numer'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Numer</TableHeaderColumn>
                    <TableHeaderColumn dataField='trasaGlownaId'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                                       dataFormat={this.renderNazwaTrasy}
                    >Trasa główna</TableHeaderColumn>
                    <TableHeaderColumn dataField='relacja' dataSort
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Relacja</TableHeaderColumn>
                    <TableHeaderColumn dataField='typ' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Typ</TableHeaderColumn>
                    <TableHeaderColumn dataField='przedzialKm' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataFormat={this.renderPrzedzialy}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Przedział [km]</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataWaznosci' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Data ważności</TableHeaderColumn>
                    <TableHeaderColumn dataField='zezwolenie' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Zezwolenie</TableHeaderColumn>
                    <TableHeaderColumn dataField='wydawca' dataSort
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={(this.props.wlaczSzukanie) ? {
                                           type: 'TextFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}
                    >Wydawca</TableHeaderColumn>
                    <TableHeaderColumn dataField='idLi'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/linie/components/LinieTable.js